// extracted by mini-css-extract-plugin
export var addButton = "_g1-0";
export var border = "_g1-8";
export var check = "_g1-h";
export var danger = "_g1-6";
export var dropdownContainer = "_g1-1";
export var editModalBody = "_g1-j";
export var footerContainer = "_g1-i";
export var fullWidth = "_g1-a";
export var hide = "_g1-9";
export var icon = "_g1-3";
export var input = "_g1-7";
export var inputFlex = "_g1-b";
export var inputWrapper = "_g1-c";
export var manualFocus = "_g1-5";
export var optionButton = "_g1-4";
export var pillWrapper = "_g1-e";
export var pointer = "_g1-2";
export var showOverflow = "_g1-f";
export var tagsFlex = "_g1-d";
export var xButton = "_g1-g";